import {MuiThemeProvider} from "@material-ui/core/styles";
import React, {Component} from "react";
import {Link, Location, Locations, NotFound} from "react-router-component";
import "./App.css";
import "./css/pikaday.css";
import "./css/w3.css";
import theme from "./Theme";
import TimeLapseScreen from "./TimeLapseScreen";
import * as API from "./util/api";
import * as Util from "./util/util";
import AboutScreen from "./views/AboutScreen";
import AccountScreen from "./views/AccountScreen";
import AssetScreen from "./views/AssetScreen";
import AssetsScreen from "./views/AssetsScreen";
import BroadcastScreen from "./views/BroadcastScreen";
import CameraCountScreen from "./views/CameraCountScreen";
import CameraScreen from "./views/CameraScreen";
import CustomMatrixScreen from "./views/CustomMatrixScreen";
import EditInputsScreen from "./views/EditInputsScreen";
import EditLevelsScreen from "./views/EditLevels";
import EditScreen from "./views/EditScreen";
import ErrorScreen from "./views/ErrorScreen";
import FaultScreen from "./views/FaultScreen";
import FaultTrackingScreen from "./views/FaultTrackingScreen";
import FloodAlertsScreen from "./views/FloodAlertsScreen";
import ForgotScreen from "./views/ForgotScreen";
import GraphScreen from "./views/GraphScreen";
import GroupsScreen from "./views/GroupsScreen";
import GSMNetworksScreen from "./views/GSMNetworksScreen";
import HistoricImagesScreen from "./views/HistoricImagesScreen";
import ImageSearchScreen from "./views/ImageSearchScreen";
import JourneyScreen from "./views/JourneyScreen";
import JourneysGlobalScreen from "./views/JourneysGlobalScreen";
import JourneysScreen from "./views/JourneysScreen";
import LoginScreen from "./views/LoginScreen";
import LogScreen from "./views/LogScreen";
import MapScreen from "./views/MapScreen";
import MatricesScreen from "./views/MatricesScreen";
import MatrixScreen from "./views/MatrixScreen";
import PairingScreen from "./views/PairingScreen";
import ResetScreen from "./views/ResetScreen";
import SettingScreen from "./views/SettingScreen";
import ShapeFilesScreen from "./views/ShapeFilesScreen";
import SubcontractorScreen from "./views/SubcontractorScreen";
import SubcontractorsScreen from "./views/SubcontractorsScreen";
import SystemListScreen from "./views/SystemListScreen";
import UserScreen from "./views/UserScreen";
import UsersScreen from "./views/UsersScreen";
import VehicleScreen from "./views/VehicleScreen";
import VehiclesScreen from "./views/VehiclesScreen";

export const NavContext = React.createContext({});

class App extends Component {

    constructor() {
        super();
        this.routerRef = React.createRef();
        this.state = {menuOpen: false};
    }

    getLinks = () => {
        let def = (Util.isSubAccount() || Util.isCommunity()) ? [{title: "Home", link: "/matrix/0"}] : [
            {title: "List", link: "/list/0"},
            {title: "Matrix", link: "/matrix/0"},
            {title: "Map", link: "/map"}
        ];
        return Util.getHistory().concat(def);
    };

    navLinks = () => {
        return this.getLinks().map(l => <Link key={l.link} href={l.link}>{l.title}</Link>);
    };

    render() {
        return [
            <div className="dropdown-content-always" onMouseEnter={e => this.setState({menuOpen: true})}
                 onMouseLeave={e => this.setState({menuOpen: false})}
                 style={{display: this.state.menuOpen ? "block" : "none", zIndex: 40000}}>
                {this.navLinks()}
            </div>,
            this.router()
        ];
    }

    didNavigate = () => {
        this.setState({menuOpen: false});
    };

    fetchBaseData() {
        API.POST("groups/list", {}, result => {
            localStorage.alert_level_name = result.result.alert_name;
            localStorage.act_con_level_name = result.result.act_con_name;
            localStorage.warning_level_name = result.result.warning_name;
        });
    }

    router() {
        if (Util.isCommunity()) {
            return (
                <NavContext.Provider value={{toggleMenu: this.toggleMenu, navigate: this.navigate}}>
                    <MuiThemeProvider theme={theme}>
                        <div style={{width: "100vw", height: "100vh", overflowY: "hidden", overflowX: "hidden"}}
                             className="bg">
                            <Locations ref={this.routerRef} onNavigation={this.didNavigate}>
                                <Location path="/" handler={<MatrixScreen navigate={this.navigate}/>}/>
                                <Location path="/matrix/:group" handler={<MatrixScreen navigate={this.navigate}/>}/>
                                <Location path="/sensor/:id" handler={GraphScreen}/>
                                <Location path="/sensor/:provider/:id" handler={GraphScreen}/>
                                <Location path="/camera/:id" handler={<CameraScreen navigate={this.navigate}/>}/>
                                <Location path="/camera/:id/head/:defaultHead"
                                          handler={<CameraScreen navigate={this.navigate}/>}/>
                                <Location path="/camera/:id/images/:date" handler={<HistoricImagesScreen navigate={this.navigate}/>}/>
                                <Location path="/camera/:id/images/:date/:hour" handler={<HistoricImagesScreen navigate={this.navigate}/>}/>
                                <Location path="/pair" handler={<PairingScreen navigate={this.navigate}/>}/>
                                <Location path="/login" handler={<PairingScreen navigate={this.navigate}/>}/>
                                <NotFound handler={ErrorScreen}/>
                            </Locations>
                        </div>
                    </MuiThemeProvider>
                </NavContext.Provider>
            );
        }
        if (Util.isSubAccount()) {
            return (
                <NavContext.Provider value={{toggleMenu: this.toggleMenu, navigate: this.navigate}}>
                    <MuiThemeProvider theme={theme}>
                        <div style={{width: "100vw", height: "100vh", overflowY: "hidden", overflowX: "hidden"}}
                             className="bg">
                            <Locations ref={this.routerRef} onNavigation={this.didNavigate}>
                                <Location path="/" handler={<MatrixScreen navigate={this.navigate}/>}/>
                                <Location path="/matrix/:group" handler={<MatrixScreen navigate={this.navigate}/>}/>
                                <Location path="/sensor/:id" handler={GraphScreen}/>
                                <Location path="/sensor/:provider/:id" handler={GraphScreen}/>
                                <Location path="/camera/:id" handler={<CameraScreen navigate={this.navigate}/>}/>
                                <Location path="/camera/:id/head/:defaultHead" handler={<CameraScreen navigate={this.navigate}/>}/>
                                <Location path="/camera/:id/images/:date" handler={<HistoricImagesScreen navigate={this.navigate}/>}/>
                                <Location path="/camera/:id/images/:date/:hour" handler={<HistoricImagesScreen navigate={this.navigate}/>}/>
                                <Location path="/login" handler={LoginScreen}/>
                                <NotFound handler={ErrorScreen}/>
                            </Locations>
                        </div>
                    </MuiThemeProvider>
                </NavContext.Provider>
            );
        }

        this.fetchBaseData();

        return (
            <NavContext.Provider value={{toggleMenu: this.toggleMenu, navigate: this.navigate}}>
                <MuiThemeProvider theme={theme}>
                    <div style={{width: "100vw", height: "100vh", overflowY: "hidden", overflowX: "hidden"}} className="bg">
                        <Locations ref={this.routerRef} onNavigation={this.didNavigate}>
                            <Location path="/" handler={<GroupsScreen navigate={this.navigate}/>}/>
                            <Location path="/log" handler={LogScreen}/>
                            <Location path="/list/:group" handler={<SystemListScreen/>}/>
                            <Location path="/map" handler={<MapScreen navigate={this.navigate}/>}/>
                            <Location path="/map/:id" handler={<MapScreen navigate={this.navigate}/>}/>
                            <Location path="/matrix/:group" handler={<MatrixScreen navigate={this.navigate}/>}/>
                            <Location path="/customMatrix/:customId" handler={<MatrixScreen navigate={this.navigate}/>}/>
                            <Location path="/sensor/:id" handler={GraphScreen}/>
                            <Location path="/sensor/:provider/:id" handler={GraphScreen}/>
                            <Location path="/camera/:id" handler={<CameraScreen navigate={this.navigate}/>}/>
                            <Location path="/camera/:id/head/:defaultHead" handler={<CameraScreen navigate={this.navigate}/>}/>
                            <Location path="/edit/:id" handler={<EditScreen navigate={this.navigate}/>}/>
                            <Location path="/levels/:id" handler={<EditLevelsScreen navigate={this.navigate}/>}/>
                            <Location path="/inputs/:id" handler={<EditInputsScreen navigate={this.navigate}/>}/>
                            <Location path="/camera/:id/images/:date" handler={<HistoricImagesScreen navigate={this.navigate}/>}/>
                            <Location path="/camera/:id/images/:date/:hour" handler={<HistoricImagesScreen navigate={this.navigate}/>}/>
                            <Location path="/camera/:id/timelapse/:date" handler={<TimeLapseScreen/>}/>
                            <Location path="/account" handler={AccountScreen}/>
                            <Location path="/users" handler={UsersScreen}/>
                            <Location path="/users/:id" handler={UserScreen}/>
                            <Location path="/settings" handler={SettingScreen}/>
                            <Location path="/login" handler={LoginScreen}/>
                            <Location path="/imageCounts" handler={<CameraCountScreen navigate={this.navigate}/>}/>
                            <Location path="/about" handler={AboutScreen}/>
                            <Location path="/matrices" handler={<MatricesScreen/>}/>
                            <Location path="/matrices/:id" handler={CustomMatrixScreen}/>
                            <Location path="/gsmNetwork" handler={GSMNetworksScreen}/>
                            <Location path="/resetPassword" handler={ResetScreen}/>
                            <Location path="/forgotPassword" handler={ForgotScreen}/>
                            <Location path="/floods/:type" handler={<FloodAlertsScreen navigate={this.navigate}/>}/>
                            <Location path="/floodArea/:floodId" handler={<MapScreen navigate={this.navigate}/>}/>
                            {/* <Location path="/gis" handler={<ShapeFilesScreen navigate={this.navigate}/>}/>
                            <Location path="/faults" handler={FaultTrackingScreen}/>
                            <Location path="/faults/:page" handler={FaultTrackingScreen}/>
                            <Location path="/fault/:id" handler={FaultScreen}/> */}
                            <Location path="/broadcast" handler={BroadcastScreen}/>
                            <Location path="/broadcast/:id" handler={BroadcastScreen}/>
                            <Location path="/images" handler={ImageSearchScreen}/>
                            {/* <Location path="/vehicles" handler={VehiclesScreen}/>
                            <Location path="/vehicles/:id" handler={VehicleScreen}/>
                            <Location path="/assets" handler={<AssetsScreen navigate={this.navigate}/>}/>
                            <Location path="/assets/:id" handler={AssetScreen}/>
                            <Location path="/journeys" handler={JourneysScreen}/>
                            <Location path="/journeys/all" handler={JourneysGlobalScreen}/>
                            <Location path="/journeys/:id" handler={JourneyScreen}/> */}
                            <Location path="/subcontractors" handler={SubcontractorsScreen}/>
                            <Location path="/subcontractors/:id" handler={SubcontractorScreen}/>
                            <NotFound handler={ErrorScreen}/>
                        </Locations>
                    </div>
                </MuiThemeProvider>
            </NavContext.Provider>
        );
    }

    toggleMenu = isOpen => {
        this.setState({menuOpen: isOpen});
    };

    navigate = link => {
        this.routerRef.current.navigate(link);
    };
}

export default App;
